import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { ProposalsLocalActions } from '@lockton-apps/shared/action/proposals';
import { ApplicationConfig } from '@lockton-apps/shared/interfaces';

export const PROPOSAL_CONFIG_FEATURE_KEY = 'proposal-config';

export interface ProposalConfigState extends EntityState<ApplicationConfig> {
  loaded: boolean;
  updating: boolean;
  error?: string | null; // last known error (if any)
}

export const proposalConfigAdapter: EntityAdapter<ApplicationConfig> =
  createEntityAdapter<ApplicationConfig>();

export const initialProposalConfigState: ProposalConfigState =
  proposalConfigAdapter.getInitialState({
    loaded: false,
    updating: false,
  });

export const reducer = createReducer(
  initialProposalConfigState,
  on(ProposalsLocalActions.getConfigSuccess, (state, { config }) =>
    proposalConfigAdapter.upsertOne(config, { ...state })
  ),
  on(ProposalsLocalActions.getConfigFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(ProposalsLocalActions.getPartnerConfigsSuccess, (state, { configs }) =>
    proposalConfigAdapter.upsertMany(configs, { ...state })
  ),
  on(ProposalsLocalActions.getPartnerConfigsFailure, (state, { error }) => ({
    ...state,
    error,
  }))
);

export function sharedProposalsReducer(
  state: ProposalConfigState | undefined,
  action: Action
) {
  return reducer(state, action);
}
